module.exports = __webpack_public_path__ + "img/pass.b016b214.png";